import { addressSchema, appearanceSchema, dateRangeSchema, deliveryAddressSchema, diningOptionSchema, hourRangeSchema, imageSchema, loyaltyAuthDataSchema, menuItemAvailabilitySchema, menuPageSchema, nutritionInfoSchema, orderedItemDbSchema, orderedItemSchema, orderedPriceOptionDbSchema, orderedPriceOptionSchema, orderEventSchema, orderLeadTimeRuleSchema, orderThrottlingRuleSchema, scheduleSchema, } from '../models/index.js';
export function getObjectSchemaFromSubtype(subtype) {
    switch (subtype) {
        case 'Address':
            return addressSchema;
        case 'Appearance':
            return appearanceSchema;
        case 'DateRange':
            return dateRangeSchema;
        case 'DeliveryAddress':
            return deliveryAddressSchema;
        case 'DiningOption':
            return diningOptionSchema;
        case 'HourRange':
            return hourRangeSchema;
        case 'Image':
            return imageSchema;
        case 'LoyaltyAuthData':
            return loyaltyAuthDataSchema;
        case 'MenuItemAvailability':
            return menuItemAvailabilitySchema;
        case 'MenuPage':
            return menuPageSchema;
        case 'NutritionInfo':
            return nutritionInfoSchema;
        case 'OrderedItem':
            return orderedItemSchema;
        case 'OrderedItemDb':
            return orderedItemDbSchema;
        case 'OrderedPriceOption':
            return orderedPriceOptionSchema;
        case 'OrderedPriceOptionDb':
            return orderedPriceOptionDbSchema;
        case 'OrderEvent':
            return orderEventSchema;
        case 'OrderLeadTimeRule':
            return orderLeadTimeRuleSchema;
        case 'OrderThrottlingRule':
            return orderThrottlingRuleSchema;
        case 'Schedule':
            return scheduleSchema;
    }
}
//# sourceMappingURL=get_object_schema_from_subtype.js.map